<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sesEdy/tc-custom/FC-9781647509392.jpg?1685203880265?1719603246569" alt="This image is the cover for the book If Life Was a Dream"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If Life Was a Dream
      </h1>
      <p class="bookDescription body article font2">
        <p>The fifty-one poems included in this collection describe the author’s internal and external sentiments and the journey of exploring human behavior and its unique presence on this planet.</p><p>Human life is filled with various phases where love, passion, suffering, rejection, acceptance, pathos, and pleasure intertwine in a homogenous fluidity that is the essence of human existence. To understand and cherish human qualities will allow us to value and dignity of human life. It must be preserved and celebrated throughout humanity.</p><p>This collection of poems raises the concerns of women and empowers their identity and voice so that women’s rights would be preserved and would resonate with people who have experienced the pain, suffering, and falling in and out of love that life offers. They accept the challenges because that is the essence of living.</p><p>Poetry is the language of the heart; it might differ from one tongue to the other, but it will always sing life’s song in a melody of quivering strings of a violin, sitar, or as ‘Bauls of Bengal’ sing: ‘floating on the chariot of life.’</p><p><em>If Life Was a Dream</em> is indeed a thought-provoking, unique, and compelling read.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shukdeb Sen
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;color:black;background:white;'>Born in Bangladesh, Shukdeb Sen moved to Calcutta (now Kolkata), India. He then immigrated to U.S.A. and has spent over a thirty-year career in teaching, research, and mentoring undergraduate students at various colleges and universities in South. <em>If Life Was a Dream</em> is his first poetry book. He has published a non-fiction book titled, <em>Black Education in White America.</em> He authored over thirty research articles in scientific journals and he currently lives in Florida, U.S.A.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e77b1ea